import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaViewContent } from '../utils/analytics';

export const useGA4PageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-RH6VQDK91G', {
        page_path: location.pathname + location.search,
      });
    }
    // Meta Pixel ViewContent on initial load + each SPA route change. Fail-safe;
    // does not affect the GA4 call above.
    trackMetaViewContent();
  }, [location]);
};
